// Must byte-match the server tool NAMEs — the name is the single contract
// between server advertisement and browser dispatch.
export const PATCH_DATASET_TOOL_NAME = "patch_dataset";
export const DELETE_DATASET_TOOL_NAME = "delete_dataset";

export const DATASET_EDIT_NO_DATASET_ERROR =
  "No dataset is in view. Open a dataset first.";
